/**
 * Runtime configuration from Vite environment variables.
 * - In demo builds (`npm run build:demo` / `npm run preview:demo`), MODE is 'demo' and VITE_DEMO_MODE is 'true'.
 * - In production builds (`npm run build`), MODE is 'production' and VITE_DEMO_MODE is 'false'.
 */
export const isDemoMode =
  import.meta.env.MODE === 'demo' || import.meta.env.VITE_DEMO_MODE === 'true';

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '/api';

const publicAsset = (file: string) =>
  `${import.meta.env.BASE_URL}${file.replace(/^\//, '')}`;

/** Public asset path for the brand logo (place file in /public) */
export const logoPath = import.meta.env.VITE_LOGO_PATH ?? publicAsset('logo.png');

/** Auth pages use the PNG logo from /public */
export const authLogoPath =
  import.meta.env.VITE_AUTH_LOGO_PATH ?? publicAsset('logo.png');

export const logoFallbackPath = publicAsset('logo.svg');

/**
 * SMS Provider Features Toggle
 * Enable SMS authentication, OTP, and notification channels when the SMS gateway is active.
 * Set VITE_ENABLE_SMS=true to enable. Default: false.
 */
export const enableSms = import.meta.env.VITE_ENABLE_SMS === 'true';
